import { connect, type ConnectedProps } from "react-redux";
import type { IStoreState } from "../../../../../../../../reducers/types";
import { setFareclassOptionFilter } from "../../../../../../actions/actions";
import { getFareclassOptionFilter } from "../../../../../../reducer/selectors";
import { FareClassFilterSelection as Component } from "./component";

const mapStateToProps = (state: IStoreState) => ({
  fareClassFilter: getFareclassOptionFilter(state),
});

const mapDispatchToProps = {
  setFareclassOptionFilter,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type FareClassFilterSelectionProps = ConnectedProps<typeof connector>;

export const ConnectedFareClassFilterSelection = connector(Component);
